import { trackEvent } from '@/services/analytics';

export function reportWebVitals() {
  if (typeof window === 'undefined') return;

  try {
    const lcpObserver = new PerformanceObserver((entryList) => {
      const entries = entryList.getEntries();
      const lastEntry = entries[entries.length - 1] as any;
      trackEvent('web_vital', {
        metric_name: 'LCP',
        value: Math.round(lastEntry.startTime),
        unit: 'ms',
      });
    });
    lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });

    let clsValue = 0;
    const clsObserver = new PerformanceObserver((entryList) => {
      for (const entry of entryList.getEntries() as any[]) {
        if (!entry.hadRecentInput) {
          clsValue += entry.value;
        }
      }
      trackEvent('web_vital', {
        metric_name: 'CLS',
        value: Math.round(clsValue * 1000) / 1000,
        unit: 'score',
      });
    });
    clsObserver.observe({ type: 'layout-shift', buffered: true });

    const fidObserver = new PerformanceObserver((entryList) => {
      const entry = entryList.getEntries()[0] as any;
      trackEvent('web_vital', {
        metric_name: 'FID',
        value: Math.round(entry.processingStart - entry.startTime),
        unit: 'ms',
      });
    });
    fidObserver.observe({ type: 'first-input', buffered: true });
  } catch (e) {
    console.warn('[WebVitals] Not supported:', e);
  }
}
